import { CSSProperties } from 'react'
import Link from 'next/link'
import { Colors } from '@kvika/audur-theme'

import styles from './AudurButtonLink.module.scss'

type Props = {
	href: string
	children: JSX.Element | string
	fillColor?: Colors
	borderColor?: Colors
	style?: CSSProperties
	openInNewTab?: boolean
	onClick?(): void
	className?: string
	ariaLabel?: string
}

const AudurButtonLink = ({
	href,
	children,
	fillColor = Colors.Transparent,
	borderColor = Colors.Transparent,
	style,
	openInNewTab,
	onClick,
	className,
	ariaLabel,
}: Props) => {
	const getAriaLabel = () => {
		if (ariaLabel) {
			return openInNewTab ? `${ariaLabel} (opens in new tab)` : ariaLabel
		}
		return openInNewTab ? 'Link opens in new tab' : undefined
	}

	const linkProps = {
		href,
		target: openInNewTab ? '_blank' : '_self',
		rel: openInNewTab ? 'noopener noreferrer' : undefined,
		onClick,
		'aria-label': getAriaLabel(),
	}

	return (
		<div className={`${styles.container} ${className}`} style={{ backgroundColor: fillColor, borderColor, ...style }}>
			<Link {...linkProps}>{children}</Link>
		</div>
	)
}

export default AudurButtonLink
